import { formatNumber } from "shared/locale/format";

interface BarCellProps {
  value: number;
  maxValue: number;
  barColor: string;
  isFRCImpact?: boolean;
}

export const BarCell = ({
  value,
  maxValue,
  barColor,
  isFRCImpact = false,
}: BarCellProps) => {
  const formattedValue = isFRCImpact
    ? `${formatNumber(value, 2)}%`
    : (formatNumber(value, 0) ?? value);
  // for FRC Impact, we use absolute values since they are negative
  const absoluteValue = isFRCImpact ? Math.abs(value) : value;
  const barWidthPercent = maxValue > 0 ? (absoluteValue / maxValue) * 100 : 0;
  const barStyle = {
    width: `${barWidthPercent}%`,
    backgroundColor: barColor,
  };

  return (
    <div className="flex flex-col justify-center items-start w-full h-full gap-1.5">
      <div className="leading-tight">{formattedValue}</div>
      <div
        className={`h-2 ${absoluteValue > 0 ? "min-w-[2px]" : "min-w-0"}`}
        style={barStyle}
      />
    </div>
  );
};
